/***
 *                                       _           _____
 *                                      | |         |  ___|
 *      __ _  __ _  ___ _ __   ___ ___  | |__   ___ |___ \
 *     / _` |/ _` |/ _ \ '_ \ / __/ _ \ | '_ \ / _ \    \ \
 *    | (_| | (_| |  __/ | | | (_|  __/ | | | | (_) /\__/ /
 *     \__,_|\__, |\___|_| |_|\___\___| |_| |_|\___/\____/
 *            __/ |
 *           |___/
 *
 *           >> https://agenceho5.com
 */
import React, { useRef } from 'react';
import { Container, Typography, Grid, IconButton, Box, Tooltip, TableCell, Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import clone from 'clone';
import ConfirmButton from '../Component/ConfirmButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { useCan } from '../Context/BackendContext';
import ListPage from '../Component/ListPage';
import UserForm from '../Form/UserForm';
import PersonIcon from '@material-ui/icons/Person';
import { UsersTable } from '../Tables/UsersTable';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import WordpressIcon from '../Icons/WordpressIcon';

const emptyUser = {
  name: null,
  email: null,
  firstName: null,
  lastName: null,
}

const UserPage = React.memo((props) => {
  // Constantes
  const ListPageRef = useRef()
  const { can } = useCan();

  // Colones du tableau
  // -- Instance
  if (can('SUPER_ADMIN')) {
    UsersTable.instance = {
      head: <TableCell align="right">Instance</TableCell>,
      row: (row) => <TableCell align='left'>{row.instance ? row.instance.name : null}</TableCell>
    }
  }
  // -- Actions
  UsersTable.actions = {
    head: <TableCell align="right">Actions</TableCell>,
    row: (row) => <TableCell align="right">
      {can('SUPER_ADMIN') ? <Tooltip title="Switcher vers ce compte utilisateur"><IconButton onClick={() => { localStorage.setItem('switchUser', row.email); document.location.href = '/' }}><SwapHorizIcon /></IconButton></Tooltip> : null}
      {
        row.wpid ?
          <Tooltip title="Il s'agit d'un utilisateur importé par le connecteur wordpress. Connectez vous à Wordpress pour le modifier"><IconButton target="_blank" href={`${row.instance.wordpress}/s2w/v1/useredit?id=${row.wpid}`}><WordpressIcon /></IconButton></Tooltip>
          :
          <Tooltip title="Modifier cet utilisateur"><IconButton onClick={() => { ListPageRef.current.setEntity(clone(row)); ListPageRef.current.setDial(true) }}><EditIcon /></IconButton></Tooltip>
      }
      <ConfirmButton title="Supprimer cet utilisateur" button={<IconButton><DeleteIcon /></IconButton>} onConfirm={() => ListPageRef.current.deleteEntity(row)} >Voulez-vous vraiment supprimer cet utilisateur de façon définitive ?</ConfirmButton>
    </TableCell >
  }

  //Création du bouton d'ajout
  const addButton = <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => ListPageRef.current.setDial(true)}>Ajouter un utilisateur</Button>

  return (<Container>
    <Grid container justifyContent="space-between" spacing={2} >
      <Grid item><Typography variant="h1"><PersonIcon /> Utilisateurs</Typography></Grid>
      <Grid item>{addButton}</Grid>
    </Grid>

    <Box mt={4}>
      <ListPage
        apiEndpoint="/api/users"
        emptyEntity={emptyUser}
        entityTable={UsersTable}
        addButton={addButton}
        editForm={UserForm}
        ref={ListPageRef}
      />
    </Box>

  </Container>)
})

export default UserPage;